//https://gist.github.com/kottenator/9d936eb3e4e3c3e02598#gistcomment-3238804
export function getRange(start: number, end: number) {
  return Array(end - start + 1)
    .fill(start)
    .map((v: number, i: number) => i + start);
}
